import styled, { css } from 'styled-components'

export const commonsStyles = css<{ $disabled?: boolean }>`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  &:disabled {
    cursor: not-allowed;
  }
`

export const Link = styled.a<{ $disabled?: boolean }>`
  ${commonsStyles}
`

export const Button = styled.button<{ $disabled?: boolean }>`
  ${commonsStyles};
  background-color: transparent;
`

export const Span = styled.span<{ $disabled?: boolean }>``
